<template>
    <div>
        <div>
            <el-button type="primary" @click="showEditFunc()">新增标签</el-button>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="userLabelList"
                    row-key="id"
                    height="100%">
                <el-table-column align="center" label="编号" type="index"/>
                <el-table-column align="center" label="标签名" prop="name"/>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="showEditFunc(scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" @click="removeFunc(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-show="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>{{form.id?'编辑标签':'新增标签'}}</h3>
                <el-form
                        ref="ruleForm"
                        class="common-popup-table"
                        label-width="100px"
                        :model="form"
                        :rules="rules">
                    <el-form-item label="标签名称：" prop="name">
                        <el-input style="width: 240px" placeholder="请输入" v-model="form.name"/>
                    </el-form-item>
                    <p v-show="form.id" class="text1">编辑后已使用该标签的玩家将同步修改标签名</p>
                </el-form>
                <footer>
                    <el-button type="small" @click="close('ruleForm')">取消</el-button>
                    <el-button type="primary" size="small" @click="submitForm('ruleForm')">确认</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                show: false,
                form: {
                    id: '',
                    name: ''
                },
                rules: {
                    name: [
                        {required: true, message: '请输入标签名', trigger: 'blur'}
                    ]
                }
            }
        },
        computed: {
            ...mapState('user', ['userLabelList'])
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('user', ['addUserLabel', 'getUserLabelList', 'updateUserLabel', 'deleteUserLabel']),
            getList() {
                this.loading = true;
                this.getUserLabelList().then(() => {
                    this.loading = false
                })
            },
            showEditFunc(row = {}) {
                this.show = true;
                this.form = {
                    id: row.id,
                    name: row.name
                };
            },
            removeFunc(row) {
                this.$confirm(`是否确认删除"${row.name}"？删除后已使用该标签的玩家将重置为未使用标签。`, '删除标签', {
                    type: 'info'
                }).then(() => {
                    this.deleteUserLabel({
                        idList: [row.id]
                    }).then(() => {
                        this.getList();
                    })
                }).catch(()=>{})
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let {id, ...other} = this.form;
                        if (id) {
                            this.updateUserLabel(this.form).then(() => {
                                this.$message.success('修改成功');
                                this.close(formName);
                                this.getList();
                            })
                        } else {
                            this.addUserLabel(other).then(() => {
                                this.$message.success('添加成功');
                                this.close(formName);
                                this.getList();
                            })
                        }
                    }
                })
            },
            close(formName) {
                this.$refs[formName].resetFields();
                this.show = false;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .text1 {
        padding: 0 0 10px 20px;
        font-size: 14px;
        color: #999;
    }
</style>